import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 467.33"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#ff4f85",
      d: "M297.68 89.31H0c13.52 98.73 65.53 138.48 111.64 159 15.28 6.8 32 9.25 48.77 9.25h183.7c0-119.93 8.28-154.87-35.14-166.9a42.47 42.47 0 0 0-11.29-1.35ZM105.07 311a94.17 94.17 0 0 1 78.29-41.84h160.82v198.17H.6ZM355.59 269.15h237.82c0 109.45-88.73 198.18-198.18 198.18h-39.64ZM358 119.17v139.72c64.79 0 180.66.48 235.9.48a565.54 565.54 0 0 0-1-99.14c-7.4-29.29 23.27-48.3 37.31-54.14 15.9-7.19 9-15.31 3.51-18.48-8.34-1.58-23.35-19.68-29.82-28.53C582.5 16 544 3 527.37 1.91 435.52-9.14 358 27.39 358 119.17Z",
      class: "cls-1"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }